export const CUSTOM_LOGO = 'custom';
export const THEMES = {
    LIGHT: 'light',
    DARK: 'dark',
    UNKNOWN: 'unknown'
};
// use only like mock data
export const providers = [
    'behave',
    'envestnet',
    'finology',
    'first-clearing',
    'flyer',
    'future-vault',
    'greenhill',
    'hubspot',
    'invent',
    'lodas',
    'morningstar',
    'redtail',
    'salesforce',
    'allianz',
    'outlook',
    'mfiles',
    'addepar',
    'msentra',
    'nitrogen',
    'wealthbox'
];
